<template>
  <div class="ly_modal_container" :style="{width: '840px', zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 v-if="detailData" class="title">소식톡톡 일반소식 상세</h1>
    </div>
    <div class="ly_modal_content" style="min-height:280px">
      <template v-if="detailData" class="table_wrapper">
        <table class="table_view">
          <caption>
            <span class="blind">소식톡톡 상세</span>
          </caption>
          <colgroup>
            <col width="15%" />
            <col />
            <col width="15%" />
            <col />
          </colgroup>
          <tbody class="table_view_body">
            <tr>
              <th>받는사람</th>
              <td colspan="3">{{detailData.rcpDesc}}</td>
            </tr>
            <tr>
              <th>최초 전송시간</th>
              <td>{{$utils.timeText(detailData.pushFirstDate)}}</td>
              <th>작성자</th>
              <td>{{detailData.userName}}</td>
            </tr>
            <tr>
              <th>제목</th>
              <td colspan="3">{{detailData.boardTitle}}</td>
            </tr>
            <tr>
              <td colspan="4">
                <div class="view" v-html="$utils.nl2br(detailData.boardContent)"></div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="btn_area">
          <button type="button" class="btn_default" @click="close">닫기</button>
        </div>
      </template>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import newsMixin from "$views/News/_mixin";
import popupMixin from "$mixins/popup";

export default {
  mixins: [newsMixin, popupMixin],
  props: {
    newsId: [String, Number]
  },
  data() {
    return {
      detailData: null
    };
  },
  mounted() {
    this.$axios
      .get(`/admin/happy/news/${this.newsId}/detail`)
      .then(({ data }) => {
        this.detailData = data.data;
        this.$nextTick(this.moveToCenter);
      });
  }
};
</script>
